export default __webpack_public_path__ + "static/media/pdf dowload.aa7b1d3d.png";